import DsPdfViewer from '@mescius/dspdfviewer';

const axios = require('axios');
var viewer;

/**
 * loadPdfViewer
 * Documentation: https://developer.mescius.com/document-solutions/javascript-pdf-viewer/api/classes/GcPdfViewer.html
 *
 * @param selector
 * @param file
 * @param id
 * @param isZeitschriften
 */
window.loadPdfViewer = function(selector, file, id, isZeitschriften = false) {
    window.insertAutoLoader();

    // Get the entire URL
    const url = window.location.href;

    // Extract the part of the URL with the GET parameter 'search'
    const searchParam = new URLSearchParams(new URL(url).search).get('search');

    // Decode the extracted parameter
    let decodedSearchParam;

    // Checking if there is a 'search' parameter in the URL and decoding it if present
    if (searchParam) {
        decodedSearchParam = decodeURIComponent(searchParam);
    }

    // PageNum
    const getPageNum = new URLSearchParams(new URL(url).search).get('pageNum');

    // Get the encoded URL for docReader
    const pdfUrl = BASE_PATH + 'typo3temp/tmp_pdf/' + file;

    // Set the license key
    DsPdfViewer.LicenseKey = 'Südtiroler Beratungsring für Obst- und Weinbau,471296854527395#B1NSNtkRtF4L7tWOvN6aHR4Tvk4d0NVUWRlSYhlbrkFaQ56Lw8kdvNme9ljQuJTc88GRTd4V8hXQFhmQzwkYVJTZ5oESyJDezhnctFDR7dWTSVHeKl5LZ3iYXFXV4EDOKBlW8IUUyk4Rml5K8YTMVxUOqpFd7U6d7U4RNBDb6skeh9kUxl6biFjb9dzVrZWUmp4LxhVZx94RadUQvM4dWt4M8BTTKlGMFZUSHFFa5J5VyQXayhEN5gnYrF5RXFVWZplNZh4ZOBTMOJnZrUGS8d7ZyxkQsJWcvllRtV6NCJzcIlWO62UbromI0IyUiwiI6QTNDJUNwUjI0ICSiwSMxADO6cDMzEjM0IicfJye=#Qf35VfiUTNFZlI0IyQiwiI8YFIyV6dllmVmRGUDdkI0IiTis7W0ICZyBlIsICMxcTNxEDIxEjMxQjMwIjI0ICdyNkIsISdhJmbpV6VgQmb5BSL4NnYPBic2OsZgcmbpJ7cn9Wd4FmclJEIyVGbvJXa4RGvDPlI0ISYONkIsISN9MzNyUDN5gjN9ITM7QjI0ICZJJye0ICRiwiI34zdxFDUzo7QXlleqdkYJd5bsllaht6QsVmNsx4KDhGaZBXVOJDZJd4Q0R7dNRUZMJjW8Z4YpRVdi96TkBjd43SdvZUOxN4RGdHbwJTTTJXMXhVWSdXRLlDZ8ZmbopkRTBTZMlEbMdnT8IUb5gdT3p';

    // Create the PDF viewer
    viewer = new DsPdfViewer(selector, {
        // eslint-disable-next-line
        file: pdfUrl,
        language: 'de',
        requireTheme: 'dark',
        // eslint-disable-next-line
        workerSrc: BASE_PATH + 'node_modules/@mescius/dspdfviewer/dspdfviewer.worker.js',
        zoomOptions: {
            minZoom: 0.5,
            maxZoom: 2.0,
            dropdownZoomFactorValues: [0.5, 1, 1.5, 2],
        },
        restoreViewStateOnLoad: {
            trackScale: false,
        },
        onBeforeOpenContextMenu: function() {
            return false;
        },
        disableHistory: true,
    });

    if (!isZeitschriften) {
        viewer.options.shortcuts['P'] = {
            ctrl: true,
            tool: function(event) {
                event.preventDefault();
            },
        };
    }

    viewer.addDefaultPanels();
    viewer.toolbarLayout.viewer.default = ['$navigation', '$split', 'zoom', '$split'];
    viewer.toolbarLayout.viewer.mobile = [];

    var toolbar = viewer.toolbar;
    var toolbarLayout = viewer.toolbarLayout;

    // Search
    toolbar.addItem({
        key: 'custom-search',
        icon: {
            type: 'svg',
            content: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff" id="custom-search-icon"><path d="M0 0h24v24H0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>',
        },
        title: 'Suche',
        checked: false,
        enabled: false,
        action: function() {
            if (!document.getElementById('custom-search')) {
                document.getElementById('top-panel').innerHTML += '<div id="custom-search">' +
                    '<input name="search" id="custom-search-input" type="text" placeholder="Suche" value="' + (decodedSearchParam ? decodedSearchParam : '') + '" onkeyup="searcher(this);">' +
                    '<span class="search-info"><span id="count-first">0</span> von <span id="count-last">0</span></span>' +
                    '<span class="search-info" onclick="navResult(\'prev\'); return false;"><i class="material-icons">navigate_before</i></span>' +
                    '<span class="search-info" onclick="navResult(\'next\'); return false;"><i class="material-icons">navigate_next</i></span>' +
                    '</div>';

                // If the decoded search parameter exists
                if (decodedSearchParam) {
                    // Trigger the 'onkeyup' event on the #custom-search-input element
                    const customSearchInput = document.getElementById('custom-search-input');
                    $(customSearchInput).trigger('keyup');
                }
            } else {
                document.getElementById('custom-search').remove();
            }
        },
        onUpdate: function(args) {
            var hasDoc = viewer.hasDocument && args.state.session.pageCount > 0;

            return {
                enabled: hasDoc,
                checked: false,
                title: '',
            };
        },
    });

    toolbarLayout.viewer.default.splice(0, 0, 'custom-search');
    toolbarLayout.viewer.mobile.splice(0, 0, 'custom-search');
    viewer.applyToolbarLayout();

    const menu = document.querySelector('.gcv-menu');
    if (menu) {
        menu.remove();
    }

    viewer.onAfterOpen.register(async () => {
        // Lock all text annotations after document open:
        const resultArr = await viewer.findAnnotation(2, {
            findField: 'annotationType',
            findAll: true,
        });

        await viewer.updateAnnotations(0, resultArr.map((data) => {
            var url = data.annotation.url;
            if (url) {
                if (data.annotation.url.includes('sbrlink://')) {
                    data.annotation.url = 'javascript:handleSbrLink(\'' + BASE_PATH + '\', \'' + data.annotation.url + '\', \'' + id + '\');';
                } else {
                    data.annotation.url = 'javascript:window.open(\'' + data.annotation.url + '\', \'_blank\')';
                }
            }
            return data.annotation;
        }));

        // Getting the closest 'button' element to the element with the ID 'custom-search-icon'
        const searchButton = document.querySelector('#custom-search-icon').closest('button');

        // Checking if the decoded parameter exists and the associated element exists
        if (decodedSearchParam && searchButton) {
            $(searchButton).trigger('click');
        }

        updatePageDisplay(viewer);
        window.addEventListener('resize', function() {
            const currentPageNumber = $('#main_toolbar_Item_3 .gcv-page-input input').attr('title').split(' / ')[0];

            // Aktuelle URL abfragen
            let url = new URL(window.location.href);

            // Prüfen, ob der GET-Parameter 'pageNum' existiert
            if (url.searchParams.has('pageNum')) {
                // Wenn vorhanden, entferne den Parameter
                url.searchParams.delete('pageNum');
            }

            // Wenn nicht vorhanden, füge den Parameter hinzu mit viewer aktuelle PageNumber
            url.searchParams.append('pageNum', currentPageNumber);

            // Aktualisiere die URL ohne die Seite neu zu laden
            history.pushState(null, '', url.href);

            // Seite neu laden
            location.reload();
        });

        // go to page num
        if (getPageNum) {
            viewer.goToPage(getPageNum - 1);
        }

        window.removeAutoLoader();

        if (viewer.pageDisplay === 'TwoPageScrolling') {
            $('.gc-btn').on('click', function() {
                // prüfe ob $(this). das attribute title="Go To Previous" hat
                if ($(this).attr('title') === 'Go To Previous') {
                    // nehme die aktuelle Seitenzahl und springe noch eine Seite zurück, außer es ist die erste Seite
                    const currentPage = viewer.pageIndex;
                    if (currentPage > 0) {
                        viewer.pageIndex = currentPage - 1;
                    }
                }

                // prüfe ob $(this). das attribute title="Go To Next" hat
                if ($(this).attr('title') === 'Go To Next') {
                    // nehme die aktuelle Seitenzahl und springe noch eine Seite weiter
                    const currentPage = viewer.pageIndex;
                    viewer.pageIndex = currentPage + 1;
                }
            });
        }
    });
};

/**
 * updatePageDisplay
 * @param viewer
 */
window.updatePageDisplay = function(viewer) {
    viewer.pageDisplay = 'OnePageScrolling';
    if (window.innerWidth < 1110) {
        viewer.zoomMode = 2;
    } else {
        viewer.zoomMode = 0;
        viewer.factor = 1.0;
    }
};

/**
 * searcher
 * @param element
 * @returns {Promise<void>}
 */
window.searcher = async function(element) {
    window.insertAutoLoader('.gcv-document-view');

    // Iterate all search results
    const searcher = viewer.searcher;

    const searchIterator = searcher.search({
        Text: element.value,
        MatchCase: false,
        StartsWith: true,
        HighlightAll: true,
        Wildcards: true,
        Proximity: true,
    });

    var searchResult = await searchIterator.next();

    if (searchResult.value) {
        searcher.highlight(searchResult.value);
    }

    document.getElementById('count-last').innerHTML = searcher._totalResultsCount;

    var searchResults = [];
    while (searchResult.value && !searchResult.done) {
        const searchResultValue = searchResult.value;

        const isDuplicate = searchResults.some(result => result.ItemIndex === searchResultValue.ItemIndex && result.PageIndex === searchResultValue.PageIndex);

        if (!isDuplicate) {
            searchResults.push(searchResultValue);
        }

        searchResult = await searchIterator.next();
    }

    document.getElementById('count-first').innerHTML = '1';
    document.getElementById('count-last').innerHTML = searcher._totalResultsCount;

    document.querySelectorAll('.search-info').forEach(e => e.style.display = 'block');

    window.removeAutoLoader();

    /**
     * nav Result
     * @param type
     */
    window.navResult = await function(type) {
        var countFirstElement = document.getElementById('count-first');

        var countFirst = parseInt(countFirstElement.innerHTML);
        var countLast = parseInt(document.getElementById('count-last').innerHTML);
        var counter = countFirst;

        // Iterate all search results
        const searcher = viewer.searcher;

        if (type === 'next') {
            counter += 1;
            if (counter <= countLast) {
                viewer.pageIndex = searchResults[counter - 1].pageIndex;
                searcher.highlight(searchResults[counter - 1]);

                countFirstElement.innerHTML = counter;
            } else {
                counter = 1;
                viewer.pageIndex = searchResults[counter - 1].pageIndex;
                searcher.highlight(searchResults[counter - 1]);

                countFirstElement.innerHTML = counter;
            }
        } else {
            counter -= 1;
            if (counter >= 1) {
                viewer.pageIndex = searchResults[counter - 1].pageIndex;
                searcher.highlight(searchResults[counter - 1]);

                countFirstElement.innerHTML = counter;
            } else {
                counter = countLast;
                viewer.pageIndex = searchResults[counter - 1].pageIndex;
                searcher.highlight(searchResults[counter - 1]);

                countFirstElement.innerHTML = counter;
            }
        }
    };
};

/**
 * handleSbrLink
 * @param requestBasePath
 * @param annotator
 * @param id
 * @returns {boolean}
 */
window.handleSbrLink = function(requestBasePath, annotator, id) {
    window.insertAutoLoader();

    // POST request
    // eslint-disable-next-line
    axios.post(requestBasePath + 'ajax/helper/additional/sbr.handleLink?LANG=' + LANG, window.object2FormData({
        annotator: annotator,
        id: id,
    })).then(function(response) {
        if (response.data.showDialog === true) {
            window.removeAutoLoader();

            // falls mehrere Targets da sind, wird dem Nutzer ein Dialog mit den verfügbaren Zielen angezeigt. Klickt der Nutzer auf eines der Ziele, dann weiter
            // eslint-disable-next-line
            window.ajaxDialog(requestBasePath + 'ajax/dialog/additional/pdf.linkOptions?LANG=' + LANG, 320, {
                post_data: {
                    data: response.data,
                },
            });
        } else {
            window.getSbrRedirectUri(requestBasePath, response.data);
        }
    }).catch(function(error) {
        window.removeAutoLoader();
        console.error('Error: ', error.message);
    });
};

/**
 * Get sbr redirect uri
 * @param requestBasePath
 * @param data
 */
window.getSbrRedirectUri = function(requestBasePath, data) {
    // eslint-disable-next-line
    axios.post(requestBasePath + 'ajax/helper/additional/sbr.redirect?LANG=' + LANG, window.object2FormData(data)).then(function(response) {
        if (response.data.dialogSettings) {
            // window.top, damit es ausserhalb vom iframe geladen wird
            window.top.ajaxDialog(response.data.dialogSettings.path, response.data.dialogSettings.width, {}, response.data.dialogSettings.class);
        } else if (response.data.redirect) {
            window.open(response.data.redirect + '&jwt=' + response.data.token, '_blank');
        } else if (response.data.relogin) {
            window.ajaxDialog(requestBasePath + 'ajax/dialog/additional/loginExpired?LANG=' + LANG, 320);
        }
        window.removeAutoLoader();
    }).catch(function(error) {
        window.removeAutoLoader();
        console.error('Error: ', error.message);
    });

    return false;
};

/**
 * process Url Click
 * @param requestBasePath
 * @param element
 */
window.processUrlClick = function(requestBasePath, element) {
    const item = {
        destination: element.dataset.destination,
        destinationParameter: element.dataset.destinationparameter,
        type: element.dataset.type,
        word: element.dataset.word,
    };

    window.getSbrRedirectUri(requestBasePath, {
        response: {
            0: item,
        },
    });
    window.ajaxDialog('close');
    return false;
};
